export class WalletSearchDTO{
  offset: number;
  limit: number;
}
